import React from "react";
import { useLanderConfig } from "../../commons/ConfigContext";
import { BannerType, sendBannerClickEvent } from "../../commons/banner";
import classes from "./MobileAppAd.module.scss";

const MOBILE_APP_BASE_URL = "https://studio.click.godaddy.com/FVXM/ac281jd9";

function buildMobileAppUrl(bannerLink?: string): string {
  const url = new URL(MOBILE_APP_BASE_URL);

  if (bannerLink) {
    try {
      const bannerUrl = new URL(bannerLink);
      const utmSource = bannerUrl.searchParams.get("utm_source");
      const utmMedium = bannerUrl.searchParams.get("utm_medium");
      const utmCampaign = bannerUrl.searchParams.get("utm_campaign");
      if (utmSource) url.searchParams.set("utm_source", utmSource);
      if (utmMedium) url.searchParams.set("utm_medium", utmMedium);
      if (utmCampaign) url.searchParams.set("utm_campaign", utmCampaign);
    } catch {
      // invalid banner link URL, skip UTM params
    }
  }

  return url.href;
}

export default function MobileAppAd() {
  const { landerConfig } = useLanderConfig();
  const bannerLink = landerConfig.lander?.banner?.link;
  const mobileAppUrl = buildMobileAppUrl(bannerLink);

  return (
    <div className={ classes.mobileAppAd }>
      <span className={ classes.headline }>Manage your domains on the go</span>
      <span className={ classes.body }>
        Download the GoDaddy app to buy, manage, and renew your domains right
        from your phone.
      </span>
      <a
        className={ classes.cta }
        href={ mobileAppUrl }
        target="_blank"
        rel="noopener noreferrer"
        onClick={ () =>
          sendBannerClickEvent(BannerType.MOBILE_APP, landerConfig)
        }
      >
        <span>Download the App</span>
        <span className={ classes.ctaArrow }>&rarr;</span>
      </a>
    </div>
  );
}
